var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.disabled,
                  expression: "!disabled"
                }
              ],
              staticStyle: { float: "right", "margin-bottom": "5px" },
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.addAirline }
            },
            [_vm._v(" " + _vm._s(_vm.$t("SystemMaintenance.Add")) + " ")]
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "200px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData,
          "show-side-bar": false
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }